
import moment from 'moment';

import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheBaseServerGet } from './helpers/axiosHelper';
import { btnLoading, byId, unixTimeStampInSeconds } from './helpers/utility';

// import { DataTable } from 'simple-datatables';


authHelper.validate().then(async () => {

    const last_profit_dat = byId('last_profit_dat');
    const submit_btn = byId('submit_btn');
    btnLoading(submit_btn, 'Fetching...', true);

    const sendAiProfitPageFun = {
        fetch: async () => {
            try {

                const response = await callTheBaseServerGet('/basic/getAiProfitData');
                axiosResponseHandler(response);
                const res = response.data;
                if (res.status === 'success') {
                    console.log(res);
                    const { last_ai_profit_sended_at } = res.aiProfitData;

                    const { dataValue } = last_ai_profit_sended_at;


                    const dateTime = moment(dataValue * 1000).format('DD/MM/YYYY LT');

                    last_profit_dat.innerHTML = dateTime;

                    const diffInSeconds = unixTimeStampInSeconds() - dataValue;
                    const diffInHr = diffInSeconds / (60 * 60);


                    if (diffInHr < 24) {
                        submit_btn.disabled = true;
                        submit_btn.innerHTML = 'Already Sended';

                    } else {
                        btnLoading(submit_btn, 'Fetching...', false);
                    }

                }


            } catch (error) {
                axiosErrorHandler(error);
            }
        },
        submit: async () => {
            try {
                btnLoading(submit_btn, 'Processing...', true);
                const response = await callTheBaseServerGet('/basic/sendAiProfitData');
                axiosResponseHandler(response);
                btnLoading(submit_btn, 'Processing...', false);
                const res = response.data;
                if (res.status === 'success') {
                    console.log(res);

                    Swal.fire({
                        icon: 'success',
                        title: 'Profit Sending Completed',

                        showConfirmButton: false,
                        timer: 5000,
                        timerProgressBar: true,

                    });
                }
                submit_btn.disabled = true;
                submit_btn.innerHTML = 'Already Sended';




            } catch (error) {
                axiosErrorHandler(error);
            }
        }
    };
    window.sendAiProfitPageFun = sendAiProfitPageFun;
    sendAiProfitPageFun.fetch();




});



